import { CSSProperties } from "react";

import type { Nullable } from "models-webgl2";

export const removeCSSFromNode = (
  node: Nullable<HTMLElement>,
  ...stylesToRemove: Array<keyof CSSProperties | string>
) => {
  if (!node) return;

  // Note: setting styles as 'style[key as any]' is  faster than 'removeProperty'
  stylesToRemove.forEach((key) => {
    if (key.startsWith("--")) {
      node.style.removeProperty(key);
    } else {
      node.style[key as any] = null as any;
    }
  });

  // remove style attribute to hide "<body style>" empty attribute in DOM.
  if (!node.style.length) node.removeAttribute("style");
};
